import { useState, useEffect } from 'react';
import { Message, Segment, Grid, Header, Image } from 'semantic-ui-react';
import { getCommonAPI } from 'hpp-fe-common';
import Brand from '../resources/logo.png';
import MalVerify from '../components/MalVerify';
import PartnerVerify from '../components/PartnerVerify';
import NotFound from '../components/NotFound';
import DPPCompanyVerify from '../components/DPPCompanyVerify';
import SerialVerify from '../components/SerialVerify';

function App() {
    const [verifyType, setVerifyType] = useState('');
    const [id, setId] = useState('');
    const [loading, setLoading] = useState(false);
    const [verifyData, setVerifyData] = useState(null);
    const [error, setError] = useState({
        error: false,
        errorMessage: '',
        errorMessageData: ''
    });

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const verifyType = urlParams.get('verifyType');  // Get type from query params
        const id = urlParams.get('id');

        setVerifyType(verifyType);
        setId(id);

        // If verifyType is provided but id is missing, set an error
        if (verifyType && !id && verifyType !== 'serialNumber') {
            setError({
                error: true,
                errorMessage: 'Invalid request parameters',
                errorMessageData: 'Missing id parameter. Please scan a valid QR code.',
            });
        }

    }, []);


    useEffect(() => {
        const fetchData = async () => {
            if (!verifyType || !id) return;

            setLoading(true);
            try {
                const { data } = await getCommonAPI().get(`/api_v1/verify/get-one?verifyType=${verifyType}&id=${id}`);

                if (data.error) {
                    setError({
                        error: true,
                        errorMessage: data.errorMessage,
                        errorMessageData: data.errorMessageData,
                    });
                } else {
                    setVerifyData(data.verifyData);
                }
            } catch (err) {
                setError({
                    error: true,
                    errorMessage: 'Error fetching data',
                    errorMessageData: err.toString(),
                });
            }
            // This runs whether the try block succeeds or an error is caught
            setLoading(false);
        };

        fetchData();
    }, [verifyType, id]);



    const renderContent = () => {
        if (loading) {
            return <Segment loading>Loading...</Segment>;
        }

        if (error.error) {
            return (
                <Message negative>
                    <Message.Header>{error.errorMessage}</Message.Header>
                    <p>{error.errorMessageData}</p>
                </Message>
            );
        }

        // If id is missing, you can also choose to show a "Not Found" message
        if (verifyType && !id && verifyType !== 'serialNumber') {
            return <NotFound />;
        }

        switch (verifyType) {
            case 'malID':
                return <MalVerify malVerifyData={verifyData} />;
            case 'partnerID':
                return <PartnerVerify partnerVerifyData={verifyData} />;
            case 'dppVerification':
                return <DPPCompanyVerify dppCompanyVerifyData={verifyData} />;
            case 'serialNumber':
                return <SerialVerify />;
            default:
                return <NotFound />;
        }
    };

    return (
        <>
            {
                !verifyType &&
                <Segment className='login-form'>
                    <style>{`
         body > div,
         body > div > div,
         body > div > div > div.login-form {
           height: 100%;
         }
       `}</style>
                    <Grid centered style={{ height: '100%' }} verticalAlign='middle'>
                        <Grid.Column style={{ maxWidth: 450 }}>
                            <Grid textAlign='center'>
                                {/* Separate rows for logo and header */}
                                <Grid.Row>
                                    <Image
                                        src={Brand}
                                        style={{ width: '150px', height: '50px', objectFit: 'contain' }}
                                        centered
                                    />
                                </Grid.Row>

                                <Grid.Row>
                                    <Header as='h3' textAlign='center'>
                                        Welcome to the Verification Portal
                                        <Header.Subheader>
                                            Hikvision South Asia
                                        </Header.Subheader>
                                    </Header>
                                </Grid.Row>
                            </Grid>

                            <Segment basic textAlign='center'>
                                <Grid.Row>
                                    <Message warning style={{ maxWidth: '400px', margin: '0 auto' }}>
                                        Please scan your QR code to proceed with the verification process.
                                        This portal allows you to verify authorized credentials efficiently.
                                    </Message>
                                </Grid.Row>
                            </Segment>

                        </Grid.Column>
                    </Grid>
                </Segment>
            }


            {
                verifyType &&
                <Segment className='login-form'>
                    <style>{`
            body > div,
            body > div > div,
            body > div > div > div.login-form {
                height: 100%;
            }
        `}</style>
                    <Grid centered style={{ height: '100%' }} verticalAlign='middle'>
                        <Grid.Column style={{ maxWidth: 450 }}>
                            <Grid textAlign='center'>

                                {/* Logo Row */}
                                <Grid.Row>
                                    <Grid.Column>
                                        <Image
                                            src={Brand}
                                            style={{ width: '150px', height: '50px', objectFit: 'contain' }}
                                            centered
                                        />
                                    </Grid.Column>
                                </Grid.Row>

                                {/* Header Row */}
                                <Grid.Row>
                                    <Grid.Column>
                                        <Header as='h3' textAlign='center' style={{ marginTop: '10px' }}>
                                            Verification Portal
                                            <Header.Subheader>
                                                Hikvision South Asia
                                            </Header.Subheader>
                                        </Header>
                                    </Grid.Column>
                                </Grid.Row>

                            </Grid>

                            {/* Error Message */}
                            {error.error ? (
                                <Segment basic textAlign="center" style={{ marginTop: '15px' }}>
                                    <Message negative>
                                        <Message.Header>🚨 Verification Failed</Message.Header>
                                        <p>{error.errorMessage}</p>
                                        <p>{error.errorMessageData}</p>
                                    </Message>
                                </Segment>
                            ) : (
                                /* Render Verification Details Directly */
                                <Segment basic textAlign="center" style={{ marginTop: '15px' }}>
                                    {renderContent()}
                                </Segment>
                            )}
                        </Grid.Column>
                    </Grid>
                </Segment>
            }


        </>
    )
}

export default App;

